function sidebarMobile(btn,sidebar){
	var $btn = $(btn),
			$sidebar = $(sidebar);

	var showSidebar = function(){
		$sidebar.addClass('open');
	}

	var hideSidebar = function(){
		$sidebar.removeClass('open');
	}

	$btn.on('click', function(){
		if (!$(this).hasClass('enabled')) {
			showSidebar();
		}else{
			hideSidebar();
		}
	})
}

sidebarMobile('.btn-sidebar','.sidebar');